import React, { useEffect } from 'react'
import Link from './Link';
import NestedLink from './NestedLink';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/slices/userSlice';
import { ACCESS_TOKEN, LOCAL_ADMIN, REPO_USER, SUPER_ADMIN } from '../../constants';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { hideSidebar } from '../../utils';
import { set_sidebar } from '../../redux/slices/uiSlice';

import { IoLogOutOutline } from "react-icons/io5";
import { BiUser } from "react-icons/bi";

const Sidebar = ({ links }) => {
  const dispatch = useDispatch();
  const location = useLocation()
  const hideDesktopSidebar = hideSidebar(location)

  const sidebar = useSelector(state => state.ui.sidebar);
  const user = useSelector(state => state.user);

  useEffect(() => {
    if (hideDesktopSidebar) {
      dispatch(set_sidebar(false))
    }

    return (() => {
      if (hideDesktopSidebar) {
        dispatch(set_sidebar(true))
      }
    })
  }, [location])


  return (
    <>
      <div className={`z-[101] transition-transform bg-secondary flex flex-col overflow-y-auto fixed top-0 bottom-0 w-[250px] pt-6 transform lg:translate-x-0 
      ${sidebar ? "translate-x-0" : "translate-x-[-100%]"} 
      ${!sidebar && hideDesktopSidebar ? "!translate-x-[-100%]" : "lgpad:translate-x-0"}
      `}>
        <div className="flex-shrink-0">
          <img src="/images/logo.png" alt="" className='mb-12 w-[160px] mx-auto' />
        </div>

        <div className="flex-grow space-y-2">
          {
            links.map((item, index) => (
              item.links ?
                <NestedLink title={item.title} Icon={item.icon} to={item.to} links={item.links} />
                :
                <Link title={item.title} Icon={item.icon} to={item.to} />

            ))
          }

        </div>

        <div className="flex-shrink-0 pb-12">
          {/* <button className="w-full flex group items-center space-x-2">
            <div className={`w-[30%] transition-all group-hover:bg-primary/20  py-5 rounded-tr-full rounded-br-full flex justify-end pr-4`}>
              <IoLogOutOutline className={`transform scale-x-[-1] text-4xl group-hover:text-primary `} />
            </div>
            <span className={`group-hover:text-primary opacity-1 font-medium text-gray-700 group-hover:text-primary text-sm `}>
              Logout
            </span>
          </button> */}

          {((user.role == SUPER_ADMIN) || (user.role == LOCAL_ADMIN)) && <Link title={<FormattedMessage id="users" defaultMessage={"Users"} />} Icon={BiUser} to={"/users"} />}

          <button onClick={() => {
            dispatch(logout())
            localStorage.removeItem(ACCESS_TOKEN)
          }} className="group block w-full">
            <div className={`group rounded-lg group-hover:bg-white/30 py-3 px-2 text-white w-[80%] mx-auto flex group items-center space-x-2 `}>
              <IoLogOutOutline className={`flex-shrink-0 text-2xl text-white/90 group-hover:text-white`} />
              <span className={`font-medium text-sm text-white/90 group-hover:text-white`}>
                <FormattedMessage id="logout" defaultMessage={"Logout"} />
              </span>
            </div>
          </button>

          <div className="flex justify-end mt-4">
            <p className="w-[89%] text-sm text-left text-white/90">
              V 0.0.1
            </p>
          </div>

        </div>

      </div>
      {
        sidebar ?
          <div className={`bg-black ${hideDesktopSidebar ? "" : " block lg:hidden"}
          bg-opacity-25 fixed top-0 left-0 right-0 bottom-0 z-[100]`} onClick={() => dispatch(set_sidebar(false))}  ></div>
          : null
      }
    </>
  )
}

export default Sidebar